var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 95,
    viewBox: "0 0 80 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M20.666 0h38.668c1.756 0 3.348 1.034 4.061 2.64L80 40H0L16.605 2.64C17.318 1.033 18.91 0 20.666 0z",
    transform: "translate(-782 -434) translate(782 434) translate(0 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M25.719 19.778H54.28c1.89 0 3.574 1.196 4.197 2.98l12.91 37.02H8.612l12.911-37.02c.623-1.784 2.306-2.98 4.197-2.98z",
    transform: "translate(-782 -434) translate(782 434) translate(0 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E6EE",
    d: "M26.667 39.778c1.227 0 2.222.995 2.222 2.222v3.111c0 2.455 1.99 4.445 4.444 4.445h13.334c2.454 0 4.444-1.99 4.444-4.445V42c0-1.227.995-2.222 2.222-2.222H80v19.444c0 4.91-3.98 8.89-8.889 8.89H8.89c-4.91 0-8.889-3.98-8.889-8.89V39.778z",
    transform: "translate(-782 -434) translate(782 434) translate(0 26)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7E8299",
    d: "M25.353 7.069l.2-.002c1.738-.02 3.162 1.374 3.181 3.111v.07c-.02 1.789-1.465 3.233-3.253 3.253l-.201.002c-1.738.02-3.162-1.374-3.18-3.111v-.07c.02-1.789 1.465-3.233 3.253-3.253z",
    transform: "translate(-782 -434) translate(782 434) translate(32.42) rotate(-162 25.417 10.285)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7E8299",
    strokeDasharray: 2,
    strokeWidth: 2,
    d: "M15.033 55.804c-12.407-7.137-16.77-13.757-13.09-19.86 5.521-9.153 34.591-2.198 37.115-10.458 1.683-5.507-1.439-9.888-9.364-13.143",
    transform: "translate(-782 -434) translate(782 434) translate(32.42)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#7E8299",
    d: "M25.417.5c.786 0 1.49.414 2.002 1.06.55.691.883 1.649.883 2.703 0 1.306-.92 2.461-2.62 3.524-2.302-1.17-3.151-2.277-3.151-3.524 0-1.054.334-2.012.883-2.703C23.927.914 24.63.5 25.417.5z",
    transform: "translate(-782 -434) translate(782 434) translate(32.42)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#7E8299",
    d: "M30.693 2.214c.902-.011 1.702.47 2.28 1.226.62.812.99 1.942.974 3.191-.019 1.566-1.1 2.972-3.115 4.273-2.576-1.352-3.543-2.673-3.525-4.166.015-1.255.414-2.398 1.057-3.229.601-.778 1.42-1.284 2.329-1.295z",
    transform: "translate(-782 -434) translate(782 434) translate(32.42) rotate(70 30.627 6.684)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d6e7222d.svg";
export { ForwardRef as ReactComponent };